import React from 'react';
import {  Container, Row, Input, Col} from 'reactstrap';


class Contact extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      
    };

    this.styles = {
      
    };
  }
  

  render() {

    return (
      
      <div id="contact">
        <Container >
          <p className="title_contact">FALE CONOSCO</p>
          <div id="contact_yellow">&nbsp;</div>
          <Row> 
              <Col xs="12" sm="6" md="6" lg="6" xl="6">
                <div>
                  <Input className="contact_form" placeholder="SEU NOME"/>
                </div>
                <div>
                  <Input className="contact_form" placeholder="SEU EMAIL"/>
                </div>
                <div>
                  <Input className="contact_form" placeholder="ASSUNTO"/>
                </div>
              </Col>
              <Col>
                <div xs="12" sm="6" md="6" lg="6" xl="6">
                  <Input type="textarea" rows="6" className="contact_form" placeholder="MENSAGEM"/>
                </div>
              </Col>
          </Row>
					<div className="button_contact"><span >ENVIAR</span></div>
        </Container>
      </div>
    );

  }

}

export default Contact;



/** WEBPACK FOOTER **
 ** ./src/components/HomePageNew/Contact.js
 **/